import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from 'react-router-dom';
import TemplateVersionHistory from './scenes/TemplateVersionHistory';
import EditTemplate from './scenes/EditTemplate';
import TemplateList from './components/TemplateList';
import Templates from './hooks';
import EditTemplates from './scenes/EditTemplate/hooks';
import CreateTemplate from './scenes/CreateTemplate';
import NewTemplate from './scenes/CreateTemplate/hooks';
import SettingsPage from './scenes/Settings';
var TemplatePage = function () {
    return _jsx("div", { children: _jsx(Templates.Provider, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/create", element: _jsx(NewTemplate.Provider, { children: _jsx(CreateTemplate, {}) }) }), _jsx(Route, { path: "/:productKey/:templateKey/:templateVersion", element: _jsx(EditTemplates.Provider, { children: _jsx(EditTemplate, {}) }) }), _jsx(Route, { path: "/:productKey/:templateKey", element: _jsx(TemplateVersionHistory, {}) }), _jsx(Route, { path: "*", element: _jsx(TemplateList, {}) }), _jsx(Route, { path: "/settings", element: _jsx(SettingsPage, {}) })] }) }) });
};
export default TemplatePage;
